import { Box, Divider, Stack, Typography } from '@mui/material';
import React from 'react';

const cellSx = {
  height: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 0,
  px: 1.5,
  py: 1,
  backgroundColor: '#eeeeee',
};

const SplitCell = ({ values }) => {
  return (
    <Stack direction="row" height="100%">
      <Box
        sx={{
          ...cellSx,
          flex: 'none',
          borderRadius: 2,
          borderEndEndRadius: 0,
          borderStartEndRadius: 0,
        }}
      >
        <Typography variant="body2" fontWeight={500} noWrap>
          {values[0]}
        </Typography>
      </Box>

      <Divider flexItem orientation="vertical" />

      <Box
        sx={{
          ...cellSx,
          flex: 'none',
          borderRadius: 2,
          borderEndStartRadius: 0,
          borderStartStartRadius: 0,
        }}
      >
        <Typography variant="body2" fontWeight={500} noWrap>
          {values[1]}
        </Typography>
      </Box>
    </Stack>
  );
};

export { SplitCell };
